<script setup lang="ts">
import {nextTick, onMounted, ref} from "vue"
import emptyImage from '@/../img/profile_done.svg'

const props = defineProps<{
  action: () => Promise<any>
}>()

const loaded = ref(false)
const error = ref(false)
const errorMessage = ref('')

const $emit = defineEmits<{
  (e: 'loaded'): void
}>()
const handleLoad = async () => {
  loaded.value = false
  error.value = false
  errorMessage.value = ''
  try {
    await props.action()
    loaded.value = true
    await nextTick(() => {
      $emit('loaded')
    })
  } catch (e: any) {
    error.value = true
    errorMessage.value = e?.data?.message ?? e?.statusText ?? e
  }
}


onMounted(() => {
  handleLoad()
})

defineExpose({
  handleLoad,
})
</script>

<template>
  <div v-if="error">
    <slot
      name="error"
      :error="errorMessage"
    >
      <v-empty-state
        :image="emptyImage"
        :text="errorMessage || 'There might be a problem with your connection or our servers. Please check your internet connection or try again later. We appreciate your patience.'"
        title="Something Went Wrong"
        color="primary"
      >
        <template #actions>
          <v-btn-primary
            color="primary"
            @click="handleLoad"
          >
            Retry Request
          </v-btn-primary>
        </template>
      </v-empty-state>
    </slot>
  </div>

  <div
    class="h-100"
    v-else-if="loaded"
  >
    <slot />
  </div>

  <div v-else>
    <slot name="loading">
      <v-container
        class="fill-height justify-center align-center"
        style="min-height: 300px"
      >
        <v-progress-circular
          :indeterminate="true"
        />
      </v-container>
    </slot>
  </div>
</template>
